export class UrlResolver {
    static resolveBaseUrl() {
        let env = this.getEnvironment();
        console.log(env)

        if (env === 'dev') {
            return 'https://postfnolcontextapifg-dev.sbx.ent-clmdig-01.aws.ent.af1platform.com/v1'
        } else if (env === 'int') {
            return 'https://postfnolcontextapifg-int.preprod.ent-clmdig-01.aws.ent.af1platform.com/v1'
        } else if (env === 'prd') {
            return 'https://postfnolcontextapifg-prod.ent-clmdig-01.aws.ent.af1platform.com/v1'
        } else if (env === 'prod') {
            return 'https://postfnolcontextapifg-prod.ent-clmdig-01.aws.ent.af1platform.com/v1'
        } else {
            return 'https://postfnolcontextapifg-dev.sbx.ent-clmdig-01.aws.ent.af1platform.com/v1'
        }
    }

    static resolveContextRouterUrl() {
        let env = this.getEnvironment();

        if (env === 'dev') {
            return 'digitalclaims-context-router-dev-sbx'
        } else if (env === 'int') {
            return 'digitalclaims-context-router-int-preprod'
        } else if (env === 'prd') {
            return 'digitalclaims-context-router'
        } else if (env === 'prod') {
            return 'digitalclaims-context-router'
        } else {
            return 'digitalclaims-context-router-dev-sbx'
        }

    }

    static resolveCCCUrl() {
        let env = this.getEnvironment();
        console.log(env)

        if (env === 'dev') {
            return 'https://apict.mycccportal.com/api'
        } else if (env === 'int') {
            return 'https://apict.mycccportal.com/api'
        } else if (env === 'prd') {
            return 'https://api.mycccportal.com/api'
        } else if (env === 'prod') {
            return 'https://api.mycccportal.com/api'
        } else {
            return 'https://apict.mycccportal.com/api'
        }
    }

    static resolveNuxeoLeg() {
        let env = this.getEnvironment();

        if (env === 'dev') {
            return 'LEG01-INT'
        } else if (env === 'int') {
            return 'LEG01-INT'
        } else if (env === 'prd') {
            return 'PROD'
        } else if (env === 'prod') {
            return 'PROD'
        } else {
            return 'LEG01-DEV'
        }
    }

    static getEnvironment() {
        const host = window.location.hostname
        const subPath = host.split('-').length > 1 ? host.split('-')[1] : host.toString().includes('localhost') ? 'local' : 'prod'
        const tier = subPath.split('.')[0];
        return tier;
    }
}